module.exports = __webpack_public_path__ + "static/media/homebg.607f976e.webp";